<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="page-header py-5 px-4">
        <button class="back-btn" mat-mini-fab [routerLink]="'/miniapps'">
            <mat-icon>
                chevron_left
            </mat-icon>
        </button>
        <label>{{miniappsDetails?.name}}</label>
    </div>
    <div>
        <form [formGroup]="editDetailsFormGroup" class="px-4">
            <mat-card style="border: 1px solid #ECECEC;border-radius: 12px;box-shadow: none;">
                <div class="row" style="margin:1% 0% 0% 1%">
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4">
                        <mat-form-field class="w-100">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Mini App display name</mat-label>
                            </div>
                            <input type="text" class="edit-label" matInput formControlName="displayName"
                                placeholder="Enter display name">
                            <mat-error
                                *ngIf="editDetailsFormGroup.controls.displayName.invalid && editDetailsFormGroup.controls.displayName.errors.required">
                                Display Name is required
                            </mat-error>
                        </mat-form-field>
                        <!-- <mat-form-field class="w-100"> -->
                            <!-- <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Type of miniapps</mat-label>
                            </div>
                            <input type="text" class="edit-label" matInput formControlName="typeOfMiniApps"
                                placeholder="Enter display name" readonly> -->
                                <div fxLayout="column">
                                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                                      <label class="mat-input-custom-label responsive-custom-font-bot-config">Choose the type of mini
                                        app*</label>
                                    </div>
                                    <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                                      <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                                      <mat-label>Select mini app</mat-label>
                                      <mat-select required formControlName="typeOfMiniApps" class="edit-label" >
                                        <!-- <mat-option class="placeholder-input" value="" disabled selected>Select mini app</mat-option> -->
                                        <mat-option value="NATIVE">Native</mat-option>
                                        <mat-option value="WEB">Web</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                <div fxLayout="column">
                                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                                      <label class="mat-input-custom-label responsive-custom-font-bot-config">Category of
                                        mini app</label>
                                    </div>
                                    <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                                      <mat-label>Select category</mat-label>
                                      <mat-select required formControlName="miniappsCategory" class="edit-label">
                                        <mat-option value="Education">Education</mat-option>
                                        <mat-option value="News">News</mat-option>
                                        <mat-option value="Games">Games</mat-option>
                                        <mat-option value="Others">Others</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                        <mat-form-field class="w-100">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Phone number*</mat-label>
                            </div>
                            <input type="text" class="edit-label" matInput formControlName="phoneNumber"
                                placeholder="Enter phone number" readonly>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4">
                        <mat-form-field class="w-100">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Description*</mat-label>
                            </div>
                            <textarea class="edit-label" matInput #message maxlength="500" cdkTextareaAutosize
                                cdkAutosizeMaxRows="4" placeholder="Type here" formControlName="description" ></textarea>
                        </mat-form-field>
                     <div fxLayout="row">
                        <div fxLayout="column">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">MiniApps profile photo*</mat-label>
                            </div>
                            <img [src]="miniappsDetails?.photo" width="70" height="70" />
                        </div>
                        <div fxLayout="column">
                            <div fxLayout="row">
                                <button type="button" class="change-btn" fxLayoutAlign="center center"
                                    (click)="selectMiniAppsIcon()">
                                    <mat-icon style="margin-right: 10px;">
                                        open_in_new
                                    </mat-icon> Select Template
                                </button>
                            </div>
                            <input #fileInput type="file" hidden (change)="fileUpload($event)" accept="image/*">
                            <button class="change-btn" fxLayoutAlign="center center"
                                (click)="fileInput.click()">
                                <mat-icon style="margin-right: 10px;" class="material-symbols-outlined">
                                    upload
                                </mat-icon> Upload Image
                            </button>
                        </div>
                     </div>
                    </div>
                </div>
            </mat-card>

        </form>
    </div>
    <div>
        <form [formGroup]="addtionalDetailsFormGroup" class="pt-4 px-3">
            <mat-card style="border: 1px solid #ECECEC;border-radius: 12px;box-shadow: none;">
                <div class="row" style="margin:1% 0% 0% 1%">
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4">
                        <!-- <div>
                            <div>
                                <mat-label class="mat-input-edit-label">Welcome banner</mat-label>
                            </div>
                            <div>
                                <img *ngIf="!welcomeBanner" [src]="miniappsDetails?.welcome_banner" width="200" height="300" />
                                <img *ngIf="welcomeBanner" [src]="welcomeBannerPreview" width="200" height="300" />
                                <p class="library-content">Select from templates library and edit the content</p>
                                <button type="button" mat-button class="verify-btn" (click)="selectTemplate()">Select Template</button>
                                <p class="library-content">Select image for profile photo as JPG or PNG SMALLER THAN 10 MB </p>
                                <button type="button" mat-button class="verify-btn" (click)="uploadTemplate()">Upload Template</button>
                                <input type="file" id="imageFileUpload" accept="image/*" (change)="selectTemplateFile($event)" style="display:none">
                            </div>
                        </div> -->
                        <div>
                            <mat-form-field class="input-full-width" floatLabel='always'>
                                <div>
                                    <mat-label class="mat-input-custom-label">Customer Support Phone Number</mat-label>
                                    <input type="text" class="placeholder-input" matInput formControlName="customer_support_phone"
                                        placeholder="Type customer support phone number" (keypress)="keyPress($event)" maxlength="20" minlength="10">
                                </div>
                                <mat-error *ngIf="addtionalDetailsFormGroup.controls.customer_support_phone.valid ||  addtionalDetailsFormGroup.controls.customer_support_phone.errors.maxlength || addtionalDetailsFormGroup.controls.customer_support_phone.errors.minlength">
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <mat-form-field class="input-full-width" floatLabel='always'>
                            <div>
                                <mat-label class="mat-input-custom-label">Customer Support Email Id*</mat-label>
                                <input type="text" class="placeholder-input" matInput formControlName="customer_support_email"
                                    placeholder="Type customer support email Id">
                            </div>
                            <mat-error *ngIf="!addtionalDetailsFormGroup.controls['customer_support_email'].valid &&
                            addtionalDetailsFormGroup.controls['customer_support_email'].touched">
                                {{ getErrorCustomerEmail() }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="input-full-width" floatLabel='always'>
                            <div>
                                <mat-label class="mat-input-custom-label">Customer Support Url</mat-label>
                                <input type="text" class="placeholder-input" matInput formControlName="customer_support_url"
                                    placeholder="Type customer support url">
                            </div>
                            <mat-error *ngIf="!addtionalDetailsFormGroup.controls['customer_support_url'].valid &&
                            addtionalDetailsFormGroup.controls['customer_support_url'].touched">
                                {{ getErrorForLink() }}
                            </mat-error>
                        </mat-form-field>
                        <div fxLayout="column" fxlayoutGap="1px">
                            <mat-card style="box-shadow: none;">
                                <mat-label class="input-label responsive-custom-font-bot-config">Mini App labels*</mat-label>
                                <div class="editor-tag input-full-width py-1" (click)="focusTagInput()">
                                    <span class="tag-item py-1 mr-2" *ngFor="let tag of tags">
                                        <span class="pl-2">{{tag}}</span>
                                        <span class="remove-tag pl-2" (click)="removeTag(tag)">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="10" fill="white" />
                                                <path d="M10.9391 9.99943L13.803 7.14179C13.9284 7.01635 13.9989 6.84623 13.9989 6.66884C13.9989 6.49146 13.9284 6.32133 13.803 6.1959C13.6776 6.07047 13.5075 6 13.3301 6C13.1528 6 12.9827 6.07047 12.8572 6.1959L10 9.06021L7.14276 6.1959C7.01735 6.07047 6.84725 6 6.66988 6C6.49252 6 6.32242 6.07047 6.19701 6.1959C6.07159 6.32133 6.00114 6.49146 6.00114 6.66884C6.00114 6.84623 6.07159 7.01635 6.19701 7.14179L9.06091 9.99943L6.19701 12.8571C6.13458 12.919 6.08504 12.9927 6.05122 13.0738C6.01741 13.155 6 13.2421 6 13.33C6 13.418 6.01741 13.505 6.05122 13.5862C6.08504 13.6674 6.13458 13.741 6.19701 13.803C6.25892 13.8654 6.33259 13.915 6.41375 13.9488C6.49491 13.9826 6.58196 14 6.66988 14C6.75781 14 6.84486 13.9826 6.92602 13.9488C7.00718 13.915 7.08085 13.8654 7.14276 13.803L10 10.9387L12.8572 13.803C12.9192 13.8654 12.9928 13.915 13.074 13.9488C13.1551 13.9826 13.2422 14 13.3301 14C13.418 14 13.5051 13.9826 13.5863 13.9488C13.6674 13.915 13.7411 13.8654 13.803 13.803C13.8654 13.741 13.915 13.6674 13.9488 13.5862C13.9826 13.505 14 13.418 14 13.33C14 13.2421 13.9826 13.155 13.9488 13.0738C13.915 12.9927 13.8654 12.919 13.803 12.8571L10.9391 9.99943Z"
                                                    fill="#386AF6" stroke="#386AF6" stroke-width="0.5" />
                                            </svg>
                                        </span>
                                    </span>
                                    <input #tagInput type="text" class="input-tag px-0" (keyup)="onKeyUp($event)" [ngStyle]="tags.length == 0 && {'width':'50%'}" [placeholder]="tags.length == 0?'Type here to add labels/tags...':''">
                                </div>
                                <p class="text-danger" *ngIf="tags_error!=''">{{tags_error}}</p>
                            </mat-card>
                          </div>


                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4" >
                        <div>
                            <mat-form-field class="input-full-width" floatLabel='always'>
                                <div>
                                    <mat-label class="mat-input-custom-label">Launch URL</mat-label>
                                    <input type="text" class="placeholder-input" matInput formControlName="webhook_url"
                                        placeholder="Type Launch URL">
                                </div>
                                <mat-error *ngIf="addtionalDetailsFormGroup.controls.webhook_url.invalid && addtionalDetailsFormGroup.controls.webhook_url.errors.pattern">
                                    Please Enter Valid Url
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div style="margin-top: 20px;">
                            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                              <label class="mat-input-custom-label responsive-custom-font-bot-config">Permissions required by the mini app</label>
                            </div>
                            <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                              <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                              <mat-label>Choose permission</mat-label>
                              <mat-select  formControlName="permissions" multiple class="edit-label">
                                <!-- <mat-option class="placeholder-input" value="" disabled selected>Select language</mat-option> -->
                                <mat-option value="CAMERA">Camera</mat-option>
                                <mat-option value="LOCATION">Location</mat-option>
                                <mat-option value="FILE_PICKER">File</mat-option>
                                <mat-option value="MICROPHONE">Microphone</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="margin-top: 20px;" hidden>
                            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                              <label class="mat-input-custom-label responsive-custom-font-bot-config">Profile information required by the mini app</label>
                            </div>
                            <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                              <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                              <mat-label>Select information</mat-label>
                              <mat-select formControlName="profileInformation" multiple class="edit-label">
                                <!-- <mat-option class="placeholder-input" value="" disabled selected>Select language</mat-option> -->
                                <mat-option value="name">Name</mat-option>
                                <mat-option value="gender">Gender</mat-option>
                                <mat-option value="countryCode">Country</mat-option>
                                <mat-option value="stateCode">State</mat-option>
                                <mat-option value="city">City</mat-option>
                                <mat-option value="mobile">Mobile number</mat-option>
                                <mat-option value="email">Email id</mat-option>
                                <mat-option value="dob">Date of birth</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                    </div>
                </div>
                <div class="text-center pt-5">
                    <button type="button" class="verify-btn px-5 py-2 res-w-100"  style="background: #386AF6; color:#fff;font-family: 'Montserrat';
                  font-style: normal;font-size: 14px; " (click)="saveMiniAppsDetails()">Submit Changes
                        <mat-icon style="vertical-align: middle;">
                            chevron_right
                        </mat-icon>
                    </button>
                </div>
            </mat-card>
        </form>
    </div>
</div>